module.exports = __webpack_public_path__ + "img/b1.60ed6606.jpg";